import { cx } from 'cva';
import { type FunctionComponent, type ReactNode } from 'react';
import styles from './PageSection.module.css';

export type PageSectionParams = {
  backgroundColor?: string;
  children?: ReactNode;
  className?: string;
  padding?: 'default' | 'inline' | 'none';
  size?: 'large' | 'medium' | 'small';
};

export const PageSection: FunctionComponent<PageSectionParams> = ({
  backgroundColor = 'inherit',
  children,
  className,
  padding = 'default',
  size = 'large',
}) => {
  return (
    <div className={cx(styles.root, className)} style={{ backgroundColor }}>
      <div
        className={cx(
          styles.container,
          padding === 'default' && styles.paddingDefault,
          padding === 'inline' && styles.paddingInline,
        )}
      >
        <div className={styles.innerRoot} data-size={size}>
          {children}
        </div>
      </div>
    </div>
  );
};
